import { swSettings } from "app/common/services/swSettings";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";

import { isChromeBrowser } from "./browserDetection";
import { isSI, isTraditionalTrialOrAfterTrialUser, isWebSolutionUser } from "./usersUtils";

export const isExtensionPromoHidden = (): boolean =>
    GrowthbookService.growthbookInstance.getFeatureValue(TestsNames.HIDE_EXTENSION_PROMO, false) === true;

export const isEligibleForExtensionPromotion = (): boolean => {
    if (isExtensionPromoHidden()) {
        return false;
    }

    const isTrialOrPostTrialUser = isTraditionalTrialOrAfterTrialUser(swSettings);

    const isCorrectSolution = !isSI(swSettings) && isWebSolutionUser(swSettings);

    return isCorrectSolution && isTrialOrPostTrialUser && isChromeBrowser();
};
